"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswersStoreContext = exports.createAnswersStore = void 0;
exports.useAnswersStore = useAnswersStore;
const react_1 = require("react");
const zustand_1 = require("zustand");
const createAnswersStore = () => {
    return (0, zustand_1.createStore)((set, get) => ({
        answers: [],
        setAnswer: (answer) => {
            set((state) => {
                const existingIndex = state.answers.findIndex((a) => a.questionId === answer.questionId);
                if (existingIndex >= 0) {
                    const newAnswers = [...state.answers];
                    newAnswers[existingIndex] = { ...newAnswers[existingIndex], ...answer };
                    return { answers: newAnswers };
                }
                const newAnswer = { ...answer };
                return { answers: [...state.answers, newAnswer] };
            });
        },
        setAnswers: (answers) => {
            set({ answers });
        },
        getAnswer: (questionId) => {
            return get().answers.find((answer) => answer.questionId === questionId);
        },
        clearAnswers: () => {
            set({ answers: [] });
        },
    }));
};
exports.createAnswersStore = createAnswersStore;
exports.AnswersStoreContext = (0, react_1.createContext)(undefined);
function useAnswersStore(selector) {
    const store = (0, react_1.useContext)(exports.AnswersStoreContext);
    if (!store) {
        throw new Error("Missing answers store provider");
    }
    return (0, zustand_1.useStore)(store, selector);
}
